// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box edit-fee-sharing">
  <div class="info info--deposit">
    <div class="info-detail">
      <span class="key">Account number</span>
      <span class="value">{{\$ctrl.account.productNumber}}</span>
    </div>
    <div class="info-detail" ng-if="\$ctrl.productName">
      <span class="key">Product name</span>
      <span class="value">{{\$ctrl.productName}}</span>
    </div>
  </div>

  <h2 class="section-header">Fee sharing</h2>

  <div ng-if="\$ctrl.loaded && \$ctrl.rows.length === 0" class="alert alert-info">
    No custom fee of this account's product type allows fee sharing.
  </div>

  <form name="form" ng-if="\$ctrl.rows.length > 0" novalidate>
    <table class="table table--generate-row-ids">
      <thead>
      <tr>
        <th>No.</th>
        <th>Custom fee</th>
        <th>Bank share (%)</th>
        <th>Partner share (%)</th>
        <th>Target product number</th>
      </tr>
      </thead>
      <tbody>
      <tr ng-repeat="row in \$ctrl.rows track by row.feeDefinitionId">
        <td></td>
        <td>{{row.feeName}}</td>
        <td>{{\$ctrl.bankShare(row) === null ? '-' : \$ctrl.bankShare(row)}}</td>
        <td>
          <input type="number"
                 name="partnerShare{{\$index}}"
                 min="0"
                 max="100"
                 step="1"
                 ng-pattern="/^\\d+\$/"
                 ng-model="row.partnerSharePercentage"
                 required/>
        </td>
        <td>
          <div class="edit-fee-sharing__target">
            <!-- MASKED product number -->
            <input ng-if="\$ctrl.productNumberMask"
                   type="text"
                   ng-model="row.targetProductNumberInput"
                   ng-model-options="{ updateOn: 'default blur', debounce: { default: 300, blur: 0 } }"
                   ng-change="\$ctrl.searchTarget(row)"
                   ng-class="{'nx-invalid': !\$ctrl.isRowValid(row)}"
                   ui-mask="{{\$ctrl.productNumberMask}}"
                   ui-options="{clearOnBlur: false}"
                   model-view-value="true"
                   autocomplete="off">
            <!-- NON-MASKED product number -->
            <input ng-if="!\$ctrl.productNumberMask"
                   type="text"
                   ng-model="row.targetProductNumberInput"
                   ng-model-options="{ updateOn: 'default blur', debounce: { default: 300, blur: 0 } }"
                   ng-change="\$ctrl.searchTarget(row)"
                   ng-class="{'nx-invalid': !\$ctrl.isRowValid(row)}"
                   autocomplete="off">
            <ul class="dropdown-menu edit-fee-sharing__results"
                style="display: block; position: absolute; width: 100%; max-height: 200px; overflow-y: auto;"
                ng-if="row.targetResults.length > 0">
              <li ng-repeat="result in row.targetResults">
                <a ng-click="\$ctrl.selectTarget(row, result)">
                  {{result.productNumber}} - {{result.customerName}}<span ng-if="result.productName"> ({{result.productName}})</span>
                </a>
              </li>
            </ul>
            <div class="edit-fee-sharing__error" ng-if="row.targetError">
              <span class="text-danger">{{row.targetError}}</span>
            </div>
            <div class="edit-fee-sharing__error" ng-if="!row.targetError && !\$ctrl.isRowValid(row)">
              <span class="text-danger">Select the target account receiving the partner share.</span>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="clearfix"></div>

    <div class="buttons">
      <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
      <button type="button" class="btn btn-primary" ng-click="\$ctrl.update()" ng-disabled="form.\$invalid || !\$ctrl.isValid()">
        Update
      </button>
    </div>
  </form>

  <div class="buttons" ng-if="\$ctrl.loaded && \$ctrl.rows.length === 0">
    <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirect()">Back</button>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/edit-fee-sharing/edit-fee-sharing.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;